import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FlaskConical, ShoppingCart, Truck, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';
import { startDemoSession } from '@/lib/demo';

const DemoEntry = () => {
  const { t } = useTranslation();
  const { hydrateFromToken } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(null);

  const enter = async (role) => {
    setBusy(role);
    try {
      const data = await startDemoSession(role);
      await hydrateFromToken(data.token, data.user);
      navigate('/dashboard');
    } catch {
      toast.error(t('demo.error'));
      setBusy(null);
    }
  };

  const Option = ({ role, icon: Icon, label, sub, testId }) => (
    <button type="button" onClick={() => enter(role)} disabled={!!busy} data-testid={testId}
      className="flex-1 flex items-center gap-3 p-3 rounded-lg border border-amber-200 bg-white hover:border-amber-400 hover:bg-amber-50 transition-colors text-left disabled:opacity-60">
      <span className="w-9 h-9 rounded-lg bg-amber-100 text-amber-700 flex items-center justify-center shrink-0">
        {busy === role ? <Loader2 size={18} className="animate-spin" /> : <Icon size={18} />}
      </span>
      <span className="min-w-0">
        <span className="block text-sm font-semibold text-slate-900">{label}</span>
        <span className="block text-xs text-slate-500 leading-snug">{sub}</span>
      </span>
    </button>
  );

  return (
    <div className="mt-4 rounded-lg border border-amber-200 bg-amber-50/70 p-4 fade-in-up-delay-1" data-testid="demo-entry">
      <p className="text-sm font-semibold text-slate-900 flex items-center gap-1.5"><FlaskConical size={16} className="text-amber-600" /> {t('demo.title')}</p>
      <p className="text-xs text-slate-600 mt-1 mb-3">{t('demo.desc')}</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <Option role="buyer" icon={ShoppingCart} label={t('demo.asBuyer')} sub={t('demo.asBuyerSub')} testId="demo-enter-buyer" />
        <Option role="seller" icon={Truck} label={t('demo.asSeller')} sub={t('demo.asSellerSub')} testId="demo-enter-seller" />
      </div>
    </div>
  );
};

export default DemoEntry;
